import React from 'react';
import styled from '@emotion/styled';
import { Icon } from '@components/common/generic-icon';
import { mixins } from '@styles/mixins';
import { TestId } from '@components/test-ids';
import { useI18NextContext } from '@components/hooks';
import { ThemeProps } from '@theme/base';

export interface DossierProps {
  url: string;
  name: string;
}

const Container: any = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  alignItems: 'center',
  ...mixins(theme).link,
  textDecoration: 'none',
  padding: theme.custom.spacing.large,
  i: {
    color: theme.custom.states.link.default
  },
  p: {
    textDecoration: 'underline'
  },
  ['&:hover, &:hover i']: {
    color: theme.custom.states.link.hover
  }
}));

const PDF: any = styled(Icon)(({ theme }: ThemeProps) => ({
  fontSize: '2.4rem',
  marginRight: theme.custom.spacing.medium
}));

const Description: any = styled.p(({ theme }: ThemeProps) => ({
  margin: 0,
  ...(theme.custom.typography.paragraph as any),
  fontWeight: 'bold',
  span: {
    fontWeight: 'normal'
  }
}));

export const Dossier = ({ url, name }: DossierProps) => {
  const t = useI18NextContext();
  return (
    <Container onClick={() => window.open(url)} data-testid={TestId.tourDossiers.document}>
      <PDF name={'mhi-download'} />
      <Description>
        {name}
        <span> - {t('common__label--view-pdf')}</span>
      </Description>
    </Container>
  );
};
